import DashboardCard from "../DashboardCard/DashboardCard"
import css from './TopUsers.module.css'
import ErrorOverlay from "../ErrorOerlay/ErrorOerlay";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";
import FullMessageOverlay from "../FullMessageOverlay/FullMessageOverlay";
import { TopUsersInterface } from "../../TopEmployeesCompany/useTopEmployeesCompany";
import React from "react";
import Tooltip from "@/shared/components/organism/Tooltip/Tooltip";

type TopUsersProps = {
  title: string;
  col: number;
  row: number;
  loading: boolean;
  error: string | null;
  fullMessage?: string;
  top: TopUsersInterface[];
  currentUserId: number | undefined;
  current: TopUsersInterface | null;
  setOpenPopup?: () => void
};

const TopUsers: React.FC<TopUsersProps> = ({
  title,
  col,
  row,
  loading,
  error,
  fullMessage,
  top,
  current,
  currentUserId,
  setOpenPopup
}) => {
  return (
    <DashboardCard col={col} rowSpan={row} height={row * 50} title={title} isHover onClick={setOpenPopup}>
      {loading ? (
        <LoadingOverlay loading />
      ) : error ? (
        <ErrorOverlay error={error} />
      ) : fullMessage ? (
        <FullMessageOverlay fullMessage={fullMessage} />
      ) : (
        <div className={css.list}>
          {top.map(emp =>
            "isEmpty" in emp && emp.isEmpty ? (
              <div key={emp.id} className={css.item}>
                <div className={css.col1}>
                  <img
                    src={emp.photoUrl}
                    alt=""
                    className={css.photo}
                    style={{ opacity: 0.3 }}
                  />
                  {emp.place}
                </div>
                <div className={css.col2} style={{ color: "#ccc" }}>
                  —
                </div>
                <div className={css.col3} style={{ color: "#ccc" }}>
                  —
                </div>
              </div>
            ) : (
              <Tooltip key={emp.id} text={emp.fullName} position="cursor">
                <div
                  className={
                    css.item +
                    (currentUserId && emp.id === currentUserId
                      ? " " + css.current
                      : "")
                  }
                >
                  <div className={css.col1}>
                    <img src={emp.photoUrl} alt="" className={css.photo} />
                    {emp.place}
                  </div>
                  <div className={css.col2}>{emp.name}</div>
                  <div className={css.col3}>{emp.percent}%</div>
                </div>
              </Tooltip>
            )
          )}
          {current && (
            <Tooltip key={current.id} text={current.fullName} position="cursor">
              <div className={css.item + " " + css.current}>
                <div className={css.col1}>
                  <img src={current.photoUrl} alt="" className={css.photo} />
                  {current.place}
                </div>
                <div className={css.col2}>{current.name}</div>
                <div className={css.col3}>{current.percent}%</div>
              </div>
            </Tooltip>
          )}
        </div>
      )}
    </DashboardCard>
  );
};

export default TopUsers;
